<template>
  <section class="seat-row row--column">
    <span
    :style="{
      '--fontFamily': style.fontFamily,
      '--fontColor1': style.fontColor1,
      '--fontColor2': style.fontColor2,
      '--fontColor3': style.fontColor3,
    }"
    class="seat seat--empty seat--column" v-for="(col, index) in columns" :key="`col_${col}_${index}`">{{ col }}</span>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: ['columns'],
  computed: {
    ...mapGetters(['style'])
  }
}
</script>
<style>
#ss-container .row--column {
  height: 20px !important;
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ColumnList.vue